<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title"
                  >Gerenciamento das Declarações Eletrônicas de Prestação de
                  Serviço de Cartórios para o Município.</span
                >
                <br />
                <span class="navigation"
                  >Emissão > Declaração Emolumentos</span
                >
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <DeclaracaoCartorioCadastro />

          <label style="font-weight: bold; font-size: 12px">Competência:</label>
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <InputText v-model="competencia" disabled />
            </div>
            <div >
              <Button
                @click="alterarCompetencia()"
                label="Alterar"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-search"
                :disabled="loading"
              />
            </div>
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <h4 class="panel-title">
              <span class="title">Declarações Geradas na Competência.</span>
            </h4>
            <DataTable
              :value="listDeclaracao"
              :paginator="true"
              :rows="10"
              class="p-datatable-responsive"
              :key="0"
              :autoLayout="true"
              style="min-width: 100%"
              :rowClass="rowClass"
            >
              <Column headerStyle="width: 1%">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button
                      class="btn btn-primary"
                      type="button"
                      id="dropdownMenuButton"
                      icon="pi pi-angle-down"
                      data-toggle="dropdown"
                      title="Opções"
                      aria-haspopup="true"
                      aria-expanded="false"
                    ></Button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        @click="impressaoDeclaracao(slotProps.data.id)"
                      >
                        <span class="pi pi-print mr-2"></span>Impressão
                        Declaração
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        @click="
                          impressaoBoletos(
                            slotProps.data.id,
                            slotProps.data.pago
                          )
                        "
                        v-if="
                          slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.semMovimento != 'Sim' &&
                            slotProps.data.idBolDebito === 'S'
                        "
                      >
                        <span class="pi pi-print mr-2"></span>Impressão
                        Boleto(s)
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        @click="encerrarDeclaracao(slotProps.data.id)"
                        v-if="
                          !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal
                        "
                      >
                        <span class="pi pi-pencil mr-2"></span>Encerrar
                        Declaração
                      </button>
                      <div
                        class="dropdown-divider"
                        v-if="
                          !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal
                        "
                      />
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        @click="cancelarDeclaracao(slotProps.data.id)"
                        v-if="!slotProps.data.dataVigenciaFinal"
                      >
                        <span class="pi pi-times mr-2"></span>Cancelar
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="id" header="Número">
                <template #body="slotProps">
                  <div :class="lineClass(slotProps.data)">
                    {{ slotProps.data.numero }}
                  </div>
                </template>
              </Column>
              <Column
                headerStyle="width: 3%"
                field="dataFormatada"
                header="Data"
              >
                <template #body="slotProps">
                  <div :class="lineClass(slotProps.data)">
                    {{ slotProps.data.dataFormatada }}
                  </div>
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="status" header="Status">
                <template #body="slotProps">
                  <div :class="lineClass(slotProps.data)">
                    {{ slotProps.data.situacao }}
                  </div>
                </template>
              </Column>
              <Column
                headerStyle="width: 5%"
                field="situacaoCalculoParcelado"
                header="Pago?"
              >
                <template #body="slotProps">
                  <div :class="lineClass(slotProps.data)">
                    {{ slotProps.data.pago }}
                  </div>
                </template>
              </Column>
              <Column
                headerStyle="width: 10%"
                field="valorPago"
                header="Valor Pago"
              >
                <template #body="slotProps">
                  <div :class="lineClass(slotProps.data)">
                    {{ slotProps.data.valorPagoFormatado }}
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
          <template>
            <Button
              @click="novaDeclaracao()"
              label="Nova Declaração"
              type="button"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-plus"
              :disabled="loading"
            />
          </template>
        </div>
      </div>
    </div>
    <Dialog
      header="Competência"
      :visible.sync="showSelectComp"
      :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
    <h1 class="titulo-header">
      Competência
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
        @click="showSelectComp = false" />
    </h1><br />
      <span class="p-fluid">
        <Dropdown
          id="filtroAno"
          v-model="filtroAno"
          :options="listAnos"
          optionLabel="name"
          placeholder="Selecione um Ano"
        />
      </span>
      <span class="p-fluid">
        <Dropdown
          id="filtroMes"
          v-model="filtroMes"
          :options="listMeses"
          optionLabel="name"
          placeholder="Selecione um Mês"
        />
      </span>
      <hr/>
      <div class="botoes-avancar-voltar">
        <Button
          label="Selecionar"
          icon="pi pi-check"
          @click="pesquisar()"
          :disabled="loading"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharSelectCompetencia()"
          class="p-button-danger"
        />
      </div>
    </Dialog>

    <Dialog
      header="Imprimir Boleto"
      :visible.sync="displayVencBoleto"
      :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
    <h1 class="titulo-header">
      Imprimir Boleto
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
        @click="displayVencBoleto = false" />
    </h1><br />
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar
            :key="keyVencBoleto"
            id="dataVencBoleto"
            name="dataVencBoleto"
            v-model="dataVencimento"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          />
        </span>
      </div>
      <template #footer>
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="imprimirBoleto()"
          v-if="tipoEmissaoBoleto === 'N'"
          :disabled="loading"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="imprimirBoletoPix()"
          v-if="tipoEmissaoBoleto === 'P'"
          :disabled="loading"
        />
        <Button
          label="Não"
          icon="pi pi-times"
          @click="hideVencBoleto()"
          class="p-button-secondary"
        />
      </template>
    </Dialog>
    <Dialog
      header="Boleto"
      :visible.sync="displayBoletos"
      :style="{ width: '35vw' }"
      :modal="true"
    >
    <h1 class="titulo-header">
      Boleto
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
        @click="displayBoletos = false" />
    </h1><br />
      <DataTable
        :value="listBoletos"
        :paginator="true"
        :rows="10"
        :autoLayout="true"
        style="min-width: 100%"
      >
        <Column
          headerStyle="width: 2.5em"
          header
          bodyStyle="text-align: center"
        >
          <template #body="slotProps">
            <Button
              type="button"
              title="Imprimir Boleto"
              class="p-button-primary mr-2"
              icon="pi pi-print"
              style="margin-right: 0.5em"
              @click="
                carregarVencimentoBoleto(
                  slotProps.data.id,
                  slotProps.data.dataVencimento,
                  'N'
                )
              "
              :disabled="loading"
              v-if="slotProps.data.pagamentoEfetuado == 'N'"
            ></Button>
            <Button
              type="button"
              title="Pagar com PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              style="margin-right: 0.5em"
              @click="
                escolhaPagamentoPix(
                  slotProps.data.id,
                  slotProps.data.dataVencimento
                )
              "
              :disabled="loading"
              v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix"
            ></Button>
            <Button
              title="Consultar Pagamento PIX"
              icon="pi pi-search"
              style="margin-right: 0.5em"
              @click="consultarPagamentoPix(slotProps.data.id)"
              v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix"
            />
          </template>
        </Column>
        <Column
          headerStyle="width: 10%"
          field="vencimentoFormatado"
          header="Vencimento"
          bodyStyle="text-align:right"
        ></Column>
        <Column
          headerStyle="width: 8em"
          field="valorFormatado"
          header="Valor"
          bodyStyle="text-align:center"
        ></Column>
      </DataTable>
      <div class="botoes-avancar-voltar">
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="hideBoletos()"
          class="p-button-danger"
        />
      </div>
    </Dialog>
    <Dialog
      :visible.sync="showEscolhaPix"
      :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="col-md-8 mb-8">
        <Button
          label="QR Code"
          icon="pi pi-bars"
          @click="criarPagamentoPix()"
          style="margin-right: 0.5em"
          :disabled="loading"
        />
        <Button
          label="Boleto"
          icon="pi pi-print"
          @click="
            carregarVencimentoBoleto(idDamAgrupamento, dataVencimento, 'P')
          "
          :disabled="loading"
        />
      </div>
      <div class="botoes-avancar-voltar">
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="showEscolhaPix = false"
          class="p-button-danger"
        />
      </div>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha
              pagar com QR Code, confirme os dados e realize o Pagamento. <br />
              <br /><span style="font-weight: bold"
                >Valor Total:
                {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="botoes-avancar-voltar">
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="showPix = false"
          class="p-button-danger"
        />
      </div>
    </Dialog>
  </div>
</template>
<script>
import DeclaracaoSimplificada from "../services/tributario/declaracao.simplificada.service";
import DeclaracaoEmolumento from "../services/tributario/declaracao.emolumento.service";
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";
import DeclaracaoCartorioCadastro from "../views/DeclaracaoCartorioCadastro";
import { QRCanvas } from "qrcanvas-vue";

export default {
  name: "declaracaoCartorio",
  props: {
    cartorio: Boolean,
  },
  components: {
    DeclaracaoCartorioCadastro,
    QRCanvas,
  },

  data() {
    return {
      keyVenc: 0,
      keyVencBoleto: 1,
      competencia: "",
      inativo: false,
      checkTodos: false,
      loading: false,
      filtro: "",
      filtroAno: "",
      filtroMes: "",
      listAnos: [],
      listMeses: [],
      listDeclaracao: [],
      listNotas: [],
      filters: {},
      currentUser: null,
      competenciaLimite: null,
      showSelectComp: false,
      displayDecSemMov: false,
      showImpressaoBoletos: false,
      idDeclaracaoSelecionada: null,
      dataVencimento: null,
      listNotasDeclaradas: [],
      declaracaoSelecionada: null,
      displayRetificar: false,
      displayBoletos: false,
      listBoletos: [],
      tipoEmissaoBoleto: "N",
      idDecLancamentoSelecionado: null,
      idDamAgrupamento: null,
      displayVencBoleto: false,
      habilitarPix: false,
      showPix: false,
      showEscolhaPix: false,
      optionsPix: {
        cellSize: 5,
        data: "hello",
      },
      pixGerado: null,
      lblTela: "Simplificada",
    };
  },

  created() {
    if (this.$router.currentRoute.path === "/declaracaoCartorio") {
      this.lblTela = "Cartório";
    }
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.currentUser = LoginService.currentUserValue;
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === "S";
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.carregarAnos();
    this.carregarMeses();
    this.carregarCompetenciaAtual();
    this.pesquisar();
  },

  methods: {
    rowClass(data) {
      return data.status === "Cancelada" || data.status === "Retificada"
        ? "red-row"
        : data.status === "Encerrada"
        ? "green-row"
        : null;
    },
    lineClass(data) {
      return data.status === "Cancelada" ||
        data.status === "Retificada" ||
        data.status === "Encerrada"
        ? "white-line"
        : null;
    },
    novaDeclaracao() {
      this.$root.$emit("declaracaoSimplificada:novo");
    },
    rolarPagina() {
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },
    alterarCompetencia() {
      this.showSelectComp = true;
    },
    fecharSelectCompetencia() {
      this.showSelectComp = false;
    },
    pesquisar() {
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;
      DeclaracaoEmolumento.findAllDeclaracoes(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      )
        .then((response) => {
          this.listDeclaracao = response.data;
        })
        .then(() => {
          this.processando(false);
          this.showSelectComp = false;
        });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    carregarAnos() {
      let ano = this.competenciaLimite.getFullYear();
      // eslint-disable-next-line
      for (var i = ano; i > ano - 10; i--) {
        this.listAnos.push({ name: i, key: i });
      }
    },
    carregarMeses() {
      this.listMeses.push({ name: "Janeiro", key: 1 });
      this.listMeses.push({ name: "Fevereiro", key: 2 });
      this.listMeses.push({ name: "Março", key: 3 });
      this.listMeses.push({ name: "Abril", key: 4 });
      this.listMeses.push({ name: "Maio", key: 5 });
      this.listMeses.push({ name: "Junho", key: 6 });
      this.listMeses.push({ name: "Julho", key: 7 });
      this.listMeses.push({ name: "Agosto", key: 8 });
      this.listMeses.push({ name: "Setembro", key: 9 });
      this.listMeses.push({ name: "Outubro", key: 10 });
      this.listMeses.push({ name: "Novembro", key: 11 });
      this.listMeses.push({ name: "Dezembro", key: 12 });
    },
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      this.filtroAno = this.listAnos.filter((local) => local.key == ano)[0];
      this.filtroMes = this.listMeses.filter((local) => local.key == mes)[0];
      this.competencia = this.filtroMes.name + "/" + ano;
    },
    selecionarTodos() {
      if (this.checkTodos) {
        this.listNotas.forEach(function(value) {
          value.selecionado = true;
        });
      } else {
        this.listNotas.forEach(function(value) {
          value.selecionado = false;
        });
      }
    },
    declarar() {
      this.processando(true);
    },
    confirmaDeclararSemMovimento() {
      this.processando(false);
      this.displayDecSemMov = true;
    },
    hideDecSemMov() {
      this.displayDecSemMov = false;
    },
    declararSemMovimento() {
      DeclaracaoSimplificada.declararSemMov(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit(
          "alert:success",
          "Declaração sem Movimento gerada com sucesso!"
        );
      });
      this.displayDecSemMov = false;
    },
    declararNotas() {
      let listNotasSelecionadas = [];
      this.listNotas.forEach(function(value) {
        if (value.selecionado) {
          listNotasSelecionadas.push(value);
        }
      });
      DeclaracaoSimplificada.declarar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key,
        "N",
        listNotasSelecionadas
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
      });
    },
    cancelarDeclaracao(idDeclaracao) {
      this.processando(true);
      DeclaracaoSimplificada.cancelar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        idDeclaracao
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit("alert:success", "Declaração cancelada com sucesso!");
      });
      this.processando(false);
    },
    encerrarDeclaracao(id) {
      this.idDeclaracaoSelecionada = id;
      this.processando(true);
      DeclaracaoSimplificada.encerrar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pesquisar();
            this.$root.$emit(
              "alert:success",
              "Declaração encerrada com sucesso!"
            );
          },
          (error) => {
            console.log(error);
            this.$root.$emit(
              "alert:error",
              "Não foi possível encerrar a Declaração, verifique com o administrador do sistema se o Serviço de Geração de DAM esta disponível!"
            );
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    carregarRetificacao(declaracao) {
      this.processando(true);
      this.declaracaoSelecionada = declaracao;
      DeclaracaoSimplificada.carregarNotasDeclaracao(
        this.declaracaoSelecionada.id
      ).then((response) => {
        console.log(response);
        this.listNotasDeclaradas = response.data;
        this.displayRetificar = true;
      });
      this.processando(false);
    },
    hideRetificar() {
      this.processando(true);
      this.declaracaoSelecionada = null;
      this.displayRetificar = false;
      this.pesquisar();
      this.rolarPagina();
      this.processando(false);
    },
    adicionarNotasDeclaracao() {
      this.processando(true);
      for (let i = this.listNotas.length - 1; i >= 0; i--) {
        if (this.listNotas[i].selecionado) {
          this.listNotasDeclaradas.push(this.listNotas[i]);
          this.listNotas.splice(i, 1);
        }
      }
      this.listNotasDeclaradas.sort(function(a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotaDeclaracao(notaDec) {
      this.processando(true);
      notaDec.selecionado = false;
      this.listNotas.push(notaDec);
      this.listNotasDeclaradas.forEach(function(item, index, object) {
        if (item.id === notaDec.id) {
          object.splice(index, 1);
        }
      });
      this.listNotas.sort(function(a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotasDeclaracao() {
      this.processando(true);
      let newList = this.listNotas.slice();
      this.listNotasDeclaradas.forEach(function(item) {
        newList.push(item);
      });
      this.listNotas = newList;
      this.listNotasDeclaradas = [];
      this.listNotas.sort(function(a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    retificarDeclaracao() {
      DeclaracaoSimplificada.retificar(
        this.currentUser.usuario.idUsuario,
        this.declaracaoSelecionada.id,
        this.listNotasDeclaradas
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit("alert:success", "Declaração retificada com sucesso!");
        this.hideRetificar();
      });
    },
    impressaoDeclaracao(id) {
      console.log(id);
      let cartorio = "N";
      if (this.$router.currentRoute.path === "/declaracaoCartorio" || this.$router.currentRoute.path === "/declaracaoCartorioEm") {
        cartorio = "S";
      }

      ReportService.imprimir("DeclaracaoMensalEmolumento", [
        {
          param: "ID",
          string: id,
        },
        {
          param: "TIPO",
          string: "N",
        },
        {
          param: "CARTORIO",
          string: cartorio,
        },
      ]).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit(
            "alert:warn",
            "Erro ao imprimir Detalhamento Declaração!"
          );
          console.log(error);
        }
      );
    },
    impressaoBoletos(id, pago) {
      console.log(pago);
      this.processando(true);
      this.idDeclaracaoSelecionada = id;
      DeclaracaoSimplificada.findBoletos(id).then((response) => {
        this.listBoletos = response.data;
      });

      this.showImpressaoBoletos = true;

      this.displayBoletos = true;
      this.processando(false);
    },
    hideBoletos() {
      this.displayBoletos = false;
    },
    escolhaPagamentoPix(idDamAgrupamento, dataVencimento) {
      this.idDamAgrupamento = idDamAgrupamento;
      this.dataVencimento = dataVencimento;
      this.showEscolhaPix = true;
    },
    criarPagamentoPix() {
      this.processando(true);
      this.showEscolhaPix = false;
      DeclaracaoSimplificada.criarPagamentoPix(
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit("alert:warn", error);
            console.log(error);
          }
        )
        .then(() => {
          this.showEscolhaPix = false;
          this.processando(false);
        });
    },
    carregarVencimentoBoleto(id, dataVencimento, tipoEmissao) {
      this.tipoEmissaoBoleto = tipoEmissao;
      this.showEscolhaPix = false;
      let d = dataVencimento.split("-");
      this.idDamAgrupamento = id;
      this.dataVencimento = new Date(d[0], d[1] - 1, d[2]);
      this.displayVencBoleto = true;
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
      this.idDecLancamentoSelecionado = null;
      this.idDamAgrupamento = null;
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      var novaData = new Date();
      if (novaData > this.dataVencimento) {
        this.dataVencimento = novaData;
      }
      DeclaracaoSimplificada.atualizarVencimento(
        this.idDeclaracaoSelecionada,
        this.dataVencimento
      )
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            ReportService.imprimir("trb_dam_a5", [
              {
                param: "RP_ID_CLIENTE",
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: "P_CONTROLE_PARCELA",
                string:
                  " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                  idGerado +
                  "')",
              },
            ]).then(
              (data) => {
                console.log(data);
              },
              (error) => {
                this.$root.$emit(
                  "alert:warn",
                  "Erro ao exibir a visualização!"
                );
                console.log(error);
              }
            );
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.hideBoletos();
          this.processando(false);
        });
    },
    consultarPagamentoPix(idDamAgrupamento) {
      if (idDamAgrupamento) {
        this.processando(true);
        DeclaracaoSimplificada.consultarPagamentoPix(
          this.idDeclaracaoSelecionada,
          idDamAgrupamento
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.hideBoletos();
              this.showPix = false;
              this.$root.$emit("alert:info", response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      DeclaracaoSimplificada.atualizarVencimento(
        this.idDeclaracaoSelecionada,
        this.dataVencimento
      )
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            DeclaracaoSimplificada.criarPagamentoPixCp(
              idGerado,
              this.idDeclaracaoSelecionada
            )
              .then(
                (response) => {
                  console.log(response);
                  this.pixGerado = response.data;
                  ReportService.imprimir("trb_dam_a5_pix", [
                    {
                      param: "RP_ID_CLIENTE",
                      string: this.currentUser.usuario.idCliente,
                    },
                    {
                      param: "QR_CODE",
                      string: this.pixGerado.qrCode,
                    },
                    {
                      param: "P_CONTROLE_PARCELA",
                      string:
                        " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                        idGerado +
                        "')",
                    },
                  ]).then(
                    (data) => {
                      console.log(data);
                    },
                    (error) => {
                      this.$root.$emit(
                        "alert:warn",
                        "Erro ao exibir a visualização!"
                      );
                      console.log(error);
                    }
                  );
                },
                (error) => {
                  this.pixGerado = null;
                  this.$root.$emit("alert:warn", error);
                  console.log(error);
                }
              )
              .then(() => {
                this.showEscolhaPix = false;
                this.processando(false);
              });
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.hideBoletos();
          this.processando(false);
        });
    },
    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === "undefined") return pad;
      if (pad_pos == "l") {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
  },
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}
/deep/ .green-row {
  background-color: #28a745 !important;
}
/deep/ .red-row {
  background-color: #fd7272 !important;
}
</style>
